/* eslint-disable jsx-a11y/anchor-has-content */
/* eslint-disable jsx-a11y/anchor-is-valid */
import useTranslations from "i18n/useTranslations";
import React, { useEffect, useContext, useState } from "react";

// import QRCode from "react-qr-code";

const Pagination = ({
  limit = 10,
  offset,
  rowCount,
  onBack = () => {
    console.log("onBack!");
  },
  onNext = () => {
    console.log("onNext!");
  },
}) => {
  const { t,lang } = useTranslations();
  const maxPage = Math.ceil(rowCount / limit);
  const currentPage = Math.floor(offset / limit) + 1;

  const onFnBack = (_currentPage, _limit) => {
    console.log("onFnBack!");
    const { limit, offset } = convertPageToLimitOffset(
      _currentPage - 1,
      _limit
    );
    console.log("offset >>", offset);
    onBack(limit, offset);
  };
  const onFnNext = (_currentPage, _limit) => {
    console.log("onFnNext!");
    const { limit, offset } = convertPageToLimitOffset(
      _currentPage + 1,
      _limit
    );
    console.log("offset >>", offset);
    onNext(limit, offset);
  };

  return (
    <div id="pPagination">
      <div className="bPagination">
        <div className="bLeft">
          {currentPage === 1 ? (
            <a></a>
          ) : (
            <a
              className="prev"
              onClick={() => onFnBack(currentPage, limit)}
            ></a>
          )}
        </div>
        <div className="bCenter">
          {lang =='th'? 'หน้า' : 'page'} {currentPage}  {lang =='th'? 'จาก' : 'of'} {maxPage}
        </div>
        <div className="bRight">{currentPage === maxPage ? (
          <a></a>
        ) : (
          <a
            className="next"
            onClick={() => onFnNext(currentPage, limit)}
          ></a>
        )}</div>
      </div>
    </div>
  );
};
export default Pagination;

function convertPageToLimitOffset(pageNumber, limit) {
  const offset = (pageNumber - 1) * limit;
  return { limit, offset };
}
